import React, { useEffect, useState } from "react";
import { Typography, Grid } from "@mui/material";
import { fetchBlogs } from "../Api/blogFetch";
import { Card, CardMedia,Divider, Box,Button} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import { deletePost } from "../Api/deletePost";


const UserDashboard = () => {
  const [userPosts, setUserPosts] = useState([]);
  const [totalPosts, setTotalPosts] = useState(0);
  const [blogs, setBlogs] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const navigate = useNavigate();
 


  const handleDelete = async (postId) => {
    console.log("postiddd", postId)
    try {
        await deletePost(postId); // Call API to delete post
        setUserPosts(prevPosts => prevPosts.filter(post => post.id !== postId)); // Remove from UI
        console.log(`Post with ID ${postId} deleted successfully.`);
    } catch (error) {
        console.error("Error deleting post:", error);
    }
};


 
const handleEdit=(post)=>{
  navigate(`/admin/${post.id}`, { state: { postData: post } });
}



  useEffect(() => {
    const fetchData = async () => {
      const result = await fetchBlogs();
      const currentUserId = localStorage.getItem("userId");

      if (currentUserId) {
        const filteredPosts = result.data.filter(
          (post) => post.user_id === currentUserId
        );
        setTotalPosts(filteredPosts.length);
        setUserPosts(filteredPosts);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const getBlogs = async () => {
      try {
        const response = await fetchBlogs();
        setBlogs(response.data);
        // setFilteredBlogs(response.data);
      } catch (err) {
        setError(err.message || "Something went wrong while fetching blogs");
      } finally {
        setLoading(false);
      }
    };

    getBlogs();
  }, []);



  const categories = ["All", ...new Set(userPosts.map((post) => post.category))];

  // Filter posts based on the selected category
  const filteredPosts =
    selectedCategory === "All"
      ? userPosts
      : userPosts.filter((post) => post.category === selectedCategory);





  
  return (
    <Box sx={{ paddingX: "200px" }}>
  {/* Top Heading */}
  <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
    User Dashboard
  </Typography>

  <Grid container spacing={3}>
    {/* Left Side - Blog Posts (70%) */}
    <Grid item xs={12} md={8} sx={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}>
      {filteredPosts.length > 0 ? (
        filteredPosts.map((post) => (
          <Card
            key={post.user_id}
            sx={{
              display: "flex",
              maxWidth: "100%",
              borderRadius: 3,
              boxShadow: 3,
              height: 160,
              marginBottom: "15px",
              backgroundColor: "#f8f9fa",
              position: 'relative',  // To position buttons absolutely inside the card
              overflow: 'hidden',  // To make sure blur doesn't spill out
              transition: 'filter 0.3s ease',
              '&:hover': {
                // '& .card-content': {
                //   filter: 'blur(5px)', // Apply blur to the content
                // },
                '& .buttons': {
                  display: 'flex', // Display buttons on hover
                },
              },
            }}
          >
            {/* Left side - Image */}
            <CardMedia
              component="img"
              image={post.blog_img}
              alt={post.title}
              sx={{
                width: "40%",
                objectFit: "cover",
                borderRadius: "8px 0 0 8px",
              }}
            />

            {/* Right side - Content */}
            <Box
              className="card-content"
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "60%",
                padding: "15px",
              }}
            >
              <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
                {post.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {post.content}
              </Typography>
            </Box>

            {/* Buttons - Edit and Delete */}
            <Box
              className="buttons"
              sx={{
                position: 'absolute',
                top: '10%',
                left: '95%',
                transform: 'translate(-50%, -50%)',
                display: 'none',
                gap: 2,
              }}
            >
              <EditIcon onClick={()=>handleEdit(post)} style={{color:'Green',cursor:'pointer'}}/>
              <DeleteIcon   onClick={() => handleDelete(post._id)} style={{color:'red',cursor:'pointer'}}/>
            </Box>
          </Card>
        ))
      ) : (
        <Typography>No posts available in this category.</Typography>
      )}
    </Grid>




    {/* Right Side - Info & Categories (30%) */}
    <Grid item xs={12} md={4} sx={{ position: "sticky", top: "20px" }}>
      {/* Dashboard Stats */}
      <Box sx={{ padding: "20px", borderRadius: "8px", backgroundColor: "#fff", boxShadow: 2, marginBottom: "20px" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
          Dashboard Overview
        </Typography>
        <Divider sx={{ marginY: "10px" }} />
        <Typography>Total Posts: <b>{userPosts.length}</b></Typography>
        <Typography>
          Today's Posts: <b>{userPosts.filter(post => post.date === new Date().toISOString().split('T')[0]).length}</b>
        </Typography>
      </Box>

      {/* Category Filters */}
      <Box sx={{ padding: "20px", borderRadius: "8px", backgroundColor: "#fff", boxShadow: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
          Categories
        </Typography>
        <Divider sx={{ marginY: "10px" }} />
        {categories.map((category) => (
          <Button
            key={category}
            variant={selectedCategory === category ? "contained" : "outlined"}
            sx={{ margin: "5px", width: "100%", textTransform: "none", fontWeight: "bold" }}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </Button>
        ))}
      </Box>
    </Grid>
  </Grid>
</Box>

  );
};

export default UserDashboard;
